import React from 'react';
import { Input as UiInput } from '@components/ui/input';
import { cn } from '@core/utils/cn';

interface InputProps extends React.ComponentProps<'input'> {
    edit?: 'true';
}

export const Input = ({ edit, className, ...props }: InputProps) => (
    <UiInput
        {...props}
        disabled={!edit || props.disabled}
        className={cn(
            !edit &&
                'border-transparent bg-transparent px-0 shadow-none disabled:opacity-100',
            className
        )}
    />
);
